<img
  alt=""
  width="16"
  height="16"
  src="assets/images/icons/download-loader.svg"
  class="loader">